import { Text, View } from '@react-pdf/renderer';
import { calculateTimeSpan, checkObjHasValues } from 'utils';

const Education = ({ styles, data = [], headerTitle, randomString }: any) => {
	return (
		<View style={styles.mainBox}>
			<View style={styles.headingBox}>
				<Text style={styles.heading}>{headerTitle}</Text>
			</View>

			<View style={styles.mainBoxInner}>
				{data?.map((res: any, idx: any) => {
					if (checkObjHasValues(res)) {
						return (
							<View key={`${idx}-${res?.instituteName}-${res?.startDate}`} style={styles.detailBox}>
								<View style={styles.detailBoxContent}>
									<Text style={styles.detailText}>{res?.degree}</Text>
									<Text
										style={styles.detailSubText}
									>{`${res?.instituteName} | ${res?.startDate.slice(0, 4)}-${res?.endDate.slice(0, 4)}`}</Text>
								</View>
							</View>
						);
					}
				})}

				{/* <View style={styles.detailBox}>
					<View style={styles.detailBoxContent}>
						<Text style={styles.detailText}>Bachelor of Technology</Text>
						<Text style={styles.detailSubText}>Abc University, Jaipur | 2016-2020</Text>
					</View>
				</View> */}
			</View>
		</View>
	);
};

export default Education;
